import { css } from 'linaria';
import { strictBreakpoints } from '../../../media';

export const formContainerStyles = css`
	display: flex;
	gap: 32px;
	padding: 24px;
	color: var(--text-primary-invert);
	background-color: var(--background-accent);
	border-radius: 8px;
	${strictBreakpoints.onlyTablet} {
		flex-direction: column;
		gap: 48px;
		padding: 40px 64px;
	}
	${strictBreakpoints.onlyMobile} {
		flex-direction: column;
		gap: 24px;
		padding: 0;
		color: var(--text-primary-invert);
	}

	a {
		text-decoration: none;
		color: var(--text-minor) !important;
	}
`;

export const fromLeftStyles = css`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1;
	gap: 16px;

	img {
		display: none;
		margin-top: 80px;
	}
	${strictBreakpoints.onlyLgDesktop} {
		padding: 56px 0 0 56px;

		img {
			display: inline-block;
		}
	}
	${strictBreakpoints.onlyDesktop} {
		padding: 40px 0 0 40px;

		img {
			display: inline-block;
		}
	}
`;
export const fromRightStyles = css`
	flex: 1;
	padding: 60px 48px 48px;
	color: var(--text-minor);
	background: var(--background-primary);
	border-radius: 8px;
	${strictBreakpoints.onlyDesktop} {
		padding-top: 52px;
	}
	${strictBreakpoints.onlyMobile} {
		padding: 24px 16px;
	}
`;
export const formDescriptionStyles = css`
	line-height: 28px !important;
	letter-spacing: 0.15px;
	${strictBreakpoints.onlyMobile} {
		line-height: 22px !important;
		letter-spacing: 0.05px;
	}
`;
